import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  answers: {},
};

const answersSlice = createSlice({
  name: "answers",
  initialState,
  reducers: {
    setAnswers: (state, action) => {
      const { level, questionId, answer, question } = action.payload;
      if (!state.answers[level]) {
        state.answers[level] = {};
      }
      state.answers[level][questionId] = { question, answer };
    },
    addMultipleAnswers: (state, action) => {
      const { level, questionId, answer, question } = action.payload;
      if (!state.answers[level]) {
        state.answers[level] = {};
      }

      if (!state.answers[level][questionId]) {
        state.answers[level][questionId] = { question, answer: "" };
      }

      let currentAnswers = state.answers[level][questionId].answer;
      if (!currentAnswers.split(", ").includes(answer)) {
        currentAnswers = currentAnswers
          ? `${currentAnswers}, ${answer}`
          : answer;
      }
      state.answers[level][questionId].answer = currentAnswers;
    },
    deleteAnswer: (state, action) => {
      const { level, questionId } = action.payload;
      if (state.answers[level]) {
        if (state.answers[level][questionId]) {
          delete state.answers[level][questionId];
        }
        if (Object.keys(state.answers[level]).length === 0) {
          delete state.answers[level];
        }
      }
    },
    resetAnswers: (state) => {
      state.answers = {};
    },
  },
});

export const { setAnswers, resetAnswers, deleteAnswer, addMultipleAnswers } =
  answersSlice.actions;
export default answersSlice.reducer;
